const initLandingNav = (container, sections, nav, navItemsById) => {

  let prevYPosition = 0
  let direction = 'up'
  let cssClassesNavSticky = nav.dataset?.landingNavStickyClass ? nav.dataset?.landingNavStickyClass.split(' ').map(c => c.trim()).filter(c => c) : []
  let cssClassesNavActiveItem = nav.dataset?.landingNavActiveItemClass ? nav.dataset?.landingNavActiveItemClass.split(' ') : []

  // Building an array of numbers starting at 0.00 and incrementing at every 0.01
  const options = {
    rootMargin: `${nav.offsetHeight * -1}px`,
    threshold: 0,
    // threshold: Array.apply(null, {length: 100}).map((n, i) => i/100)
  }

  const getTargetSection = (entry) => {
    const index = sections.findIndex((section) => section == entry.target)
    
    if (index >= sections.length - 1) {
    return entry.target
    } else {
    return sections[index + 1]
    }
  }

  const shouldUpdate = (entry) => {
    if (direction === 'down' && !entry.isIntersecting) {
      return true
    }

    if (direction === 'up' && entry.isIntersecting) {
      return true
    }
    
    return false
  }

  /**
   * Add the CSS classes provided via `data-landing-nav-active-item-class` to
   * the active nav item.
   */
  const updateNav = (target) => {
    if (target) {
      let currentItem = typeof navItemsById[target.id] !== 'undefined' ? navItemsById[target.id] : null

      if (currentItem) {
        Object.values(navItemsById).forEach(item => {
          cssClassesNavActiveItem.forEach(cssClass => item.classList.remove(cssClass))
        })
        cssClassesNavActiveItem.forEach(cssClass => currentItem.classList.add(cssClass))
      }
    }
  }

  const onIntersectSection = (entries, observer) => {
    entries.forEach((entry) => {
      // console.log(window.scrollY, prevYPosition)
      
      if (window.scrollY > prevYPosition) {
        direction = 'down'
      } else {
        direction = 'up'
      }
      
      prevYPosition = window.scrollY
      
      const target = direction === 'down' ? getTargetSection(entry) : entry.target

      if (shouldUpdate(entry)) {
        updateNav(target)
      }

      // Fade
      // if (entry.isIntersecting) {
      //  // Rounding the intersectionRatio to 2 decimals
      //  const scale = Math.round((entry.intersectionRatio)*100)/100;
      //  entry.target.style.opacity = scale;
      // }
    })
  }

  /**
   * Manually check if the first nav item should be set to active,
   * ex. when header first becomes sticky.
   */
  const updateFirstNavItem = () => {
    let firstSection = sections[0]
    if (shouldUpdate(firstSection)) {
      updateNav(firstSection)
    }
  }

  document.addEventListener('readystatechange', e => {
    if (e.target.readyState === 'complete') {
      updateFirstNavItem()
    }
  })

  const obsSection = new IntersectionObserver(onIntersectSection, options)

  sections.forEach((section) => {
    if (section) {
      obsSection.observe(section)
    }
  })

  const onIntersectHeader = (entries, observer) => {
    updateFirstNavItem()
    entries.forEach((entry) => {
      let isCurrentlySticky = entry.intersectionRatio < 1
      cssClassesNavSticky.forEach(className => entry.target.classList.toggle(className, isCurrentlySticky))
    })
  }

  /**
   * Observe the `nav`, to add and remove the shadow. CSS-only approaches no
   * longer work in iOS.
   * @see https://stackoverflow.com/a/57991537/864799
   */
  const initHeader = () => {
    const obsHeader = new IntersectionObserver(onIntersectHeader, {
      threshold: [1],
      rootMargin: '-1px 0px 0px 0px',
    })

    obsHeader.observe(nav)
  }

  initHeader()
}

const LandingRoute = () => {

  const landingContainer = document.querySelector('[data-landing-container]')

  if (landingContainer) {

    // Sticky, auto-updating nav
    const landingNav = document.querySelector('[data-landing-container] [data-landing-nav]')

    if (!landingNav) {
      return
    }

    const landingNavAnchors = landingNav.querySelectorAll('a[href]')
    let landingNavItemsById = {}

    for (let el of landingNavAnchors) {
      let href = el.getAttribute('href')
      if (href && href[0] === '#') {
        let id = href.split('#')[1]
        landingNavItemsById[id] = el
      }
    }

    let landingNavItemsKeys = Object.keys(landingNavItemsById)

    // Sections come from the IDs in the na
    const landingSections = landingNavItemsKeys.map(id => document.getElementById(id)) || document.querySelectorAll('[data-landing-container] [data-landing-section][id]')

    initLandingNav(landingContainer, landingSections, landingNav, landingNavItemsById)

    // Array.from(pricingTableEls).forEach(el => {
    //   initLandingNav(el)
    // })

  }

};

export default LandingRoute;
